import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';
import { FormWithValidation } from 'shared/form';

export const StyledLoginFormWithValidation = styled(FormWithValidation)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${ThemePrisma.spacing.medium};
  padding: ${ThemePrisma.spacing.medium};
  width: 100%;
  z-index: 1;
  margin-right: 50px;

  span[color='danger'] {
    color: ${ThemePrisma.colors.red[4]} !important;

    svg {
      color: ${ThemePrisma.colors.red[4]} !important;
    }
  }
`;

export const LoginFormTitle = styled.p(
  () =>
    ({
      ...ThemePrisma.fonts.title.m.highContrast,
      color: ThemePrisma.colors.gray[1],
    }) as any,
);

export const ForgotPasswordLink = styled.p`
  font-family: ${ThemePrisma.fonts.title.xs.midContrast.fontFamily};
  font-size: ${ThemePrisma.fonts.title.xs.midContrast.fontSize};
  font-weight: ${ThemePrisma.fonts.title.xs.midContrast.fontWeight};
  letter-spacing: ${ThemePrisma.fonts.title.xs.midContrast.letterSpacing};
  line-height: ${ThemePrisma.fonts.title.xs.midContrast.lineHeight};
  cursor: pointer;
  margin: 0 auto;
  color: ${ThemePrisma.colors.gray[1]};
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }

  a {
    color: ${ThemePrisma.colors.gray[1]};
  }
`;
